export enum AdminFeatureFlags {
	SUPER_ADMIN = 0, // ALL PERMISSIONS, INCLUDING CHANGING ADMIN ROLES
	/** @deprecated Use USER instead */
	ADMIN = 1,
	/** @deprecated Use USER instead */
	DEVELOPER = 2,
	/** @deprecated Use USER instead */
	INVESTOR = 3,
	/** @deprecated Use USER instead */
	DASHBOARD_USER = 4,
	USER = 5,
}
